/**
 * PlotViewer — displays provenance-tagged matplotlib plot images.
 *
 * Shows static plot images from the Python SDK with their ARQO tags.
 * For interactive exploration, use the DataExplorer (AG Grid) instead.
 */

import { Box, Text } from "@radix-ui/themes";
import { useQuery } from "@tanstack/react-query";
import { useSelection } from "../../hooks/useSelection";
import { fetchPlot } from "../../api/plots";

export function PlotViewer() {
  const { selectedArtifactId } = useSelection();

  const { data: plot, isLoading } = useQuery({
    queryKey: ["plot-detail", selectedArtifactId],
    queryFn: () => fetchPlot(selectedArtifactId!),
    enabled: !!selectedArtifactId,
  });

  if (!selectedArtifactId) {
    return (
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Text color="gray">Select a plot artifact to view it here.</Text>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Text color="gray">Loading plot...</Text>
      </Box>
    );
  }

  const imageUrl =
    plot?.image_url ?? `/api/plots/${selectedArtifactId}/image`;

  return (
    <Box style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <img
        src={imageUrl}
        alt={plot?.title ?? "Provenance-tagged plot"}
        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
      />
    </Box>
  );
}
